// src/hooks/useNavigation.js
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { 
  BarChart3, 
  TrendingUp, 
  Shield, 
  Banknote, 
  Heart, 
  Building, 
  ShieldUser
} from 'lucide-react';
import preloader from '../services/preloader';

export const useNavigation = () => {
  const navigate = useNavigate();
  const [shouldScrollToContent, setShouldScrollToContent] = useState(false);

  // הגדרת קטגוריות עם מידע מלא
  const savingsCategories = [
    {
      id: 'study-funds',
      title: 'קרנות השתלמות',
      subtitle: '(גמל-נט)',
      description: 'קרנות השתלמות עם הטבות מס',
      icon: BarChart3,
      color: 'bg-blue-500',
      gradient: 'from-blue-500 to-blue-600',
      dataSource: 'גמל-נט',
      searchPlaceholder: 'חפש קרן השתלמות לפי שם או מספר...',
      url: '/compare/study-funds'
    },
    {
      id: 'pension-savings',
      title: 'קופות גמל',
      subtitle: '(גמל-נט)',
      description: 'קופות גמל לפיצויים ופנסיה',
      icon: Banknote,
      color: 'bg-green-500',
      gradient: 'from-green-500 to-green-600',
      dataSource: 'גמל-נט',
      searchPlaceholder: 'חפש קופת גמל לפי שם או מספר...',
      url: '/compare/pension-savings'
    },
    {
      id: 'investment-funds',
      title: 'קופות גמל להשקעה',
      subtitle: '(גמל-נט)',
      description: 'קופות גמל להשקעה ארוכת טווח',
      icon: TrendingUp,
      color: 'bg-purple-500',
      gradient: 'from-purple-500 to-purple-600',
      dataSource: 'גמל-נט',
      searchPlaceholder: 'חפש קופת גמל השקעה לפי שם או מספר...',
      url: '/compare/investment-funds'
    },
    {
      id: 'insurance-savings',
      title: 'פוליסות חיסכון',
      subtitle: '(ביטוח-נט)',
      description: 'פוליסות חיסכון וביטוח משולב',
      icon: Shield,
      color: 'bg-orange-500',
      gradient: 'from-orange-500 to-orange-600',
      dataSource: 'ביטוח-נט',
      searchPlaceholder: 'חפש פוליסת חיסכון לפי שם או מספר...',
      url: '/compare/insurance-savings'
    },
    {
      id: 'insurance-management',
      title: 'ביטוח מנהלים',
      subtitle: '(ביטוח-נט)',
      description: 'קרנות השקעה של חברות ביטוח',
      icon: ShieldUser,
      color: 'bg-teal-500',
      gradient: 'from-teal-500 to-teal-600',
      dataSource: 'ביטוח-נט',
      searchPlaceholder: 'חפש קרן ביטוח מנהלים לפי שם או מספר...',
      url: '/compare/insurance-management'
    },
    {
      id: 'pension-plans',
      title: 'קרנות פנסיה',
      subtitle: '(פנסיה-נט)',
      description: 'קרנות פנסיה וקצבאות',
      icon: Building,
      color: 'bg-red-500',
      gradient: 'from-red-500 to-red-600',
      dataSource: 'פנסיה-נט',
      searchPlaceholder: 'חפש קרן פנסיה לפי שם או מספר...',
      url: '/compare/pension-plans'
    },
    {
      id: 'child-savings',
      title: 'תוכנית חיסכון לכל ילד',
      subtitle: '(גמל-נט)',
      description: 'תוכניות חיסכון מיועדות לילדים',
      icon: Heart,
      color: 'bg-pink-500',
      gradient: 'from-pink-500 to-pink-600',
      dataSource: 'גמל-נט',
      searchPlaceholder: 'חפש תוכנית חיסכון לילד לפי שם או מספר...',
      url: '/compare/child-savings'
    }
  ];

  const handleCategoryChange = (categoryId) => {
    const category = savingsCategories.find(cat => cat.id === categoryId);
    
    if (category) {
      setShouldScrollToContent(true); // הגדרת דגל לגלילה
      navigate(category.url);
      document.title = `השוואת ${category.title} | מערכת השוואת מוצרי חיסכון`;
      preloader.preloadCategory(categoryId);
    } else {
      navigate('/');
      document.title = 'השוואת מוצרי חיסכון | נתונים אמיתיים מהממשלה';
    }
  };

  const goToHomePage = () => {
    navigate('/');
    document.title = 'השוואת מוצרי חיסכון | נתונים אמיתיים מהממשלה';
  };

  return { 
    handleCategoryChange, 
    goToHomePage,
    shouldScrollToContent, 
    setShouldScrollToContent,
    savingsCategories
  };
};